// extracted by css-extract-rspack-plugin
export default {"tabs-label":"tabs-label-MxvQOg","tabsLabel":"tabs-label-MxvQOg"};